import { defineMessages } from "react-intl";

export const loginMessages = defineMessages({
  passwordNotSet: {
    defaultMessage: "Password not set.",
    id: "login-page.login.error.password_not_set"
  },
  passwordPlaceholder: {
    defaultMessage: "Enter password",
    id: "login-page.password.placeholder"
  },
  usernameNotSet: {
    defaultMessage: "Username not set.",
    id: "login-page.login.error.username_not_set"
  },
  usernamePlaceholder: {
    defaultMessage: "Enter Username",
    id: "login-page.username.placeholder"
  }
});



// WEBPACK FOOTER //
// ./src/scenes/login-page/messages.ts